module.exports = __webpack_public_path__ + "img/IMG_1962_P_WoodMatted_MockedUp.1a45f206.jpg";